import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-primary-dark to-[#001a2e] border-t-2 border-primary-blue/40" style={{ boxShadow: '0 -4px 40px rgba(0, 212, 255, 0.4)' }}>
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <img
                src="https://static.readdy.ai/image/2733261fde4eb6ca5d5b92336d650a8a/8ce09f35fa7806c6d32ab167cebd341b.png"
                alt="Marche Logo"
                className="w-12 h-12 object-contain"
                style={{ filter: 'drop-shadow(0 0 15px rgba(0, 212, 255, 0.8))' }}
              />
              <h3 className="text-3xl font-orbitron font-bold text-white" style={{ textShadow: '0 0 30px rgba(0, 212, 255, 1)' }}>
                MARCHE
              </h3>
            </div>
            <p className="text-gray-400 font-inter text-sm leading-relaxed">
              The Future of Car Perfection
            </p>
            <div className="flex items-center gap-5">
              <a href="#" className="w-10 h-10 flex items-center justify-center text-primary-blue hover:text-white transition-all duration-300 cursor-pointer" style={{ textShadow: '0 0 10px rgba(0, 212, 255, 0.6)' }}>
                <i className="ri-instagram-line text-2xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center text-primary-blue hover:text-white transition-all duration-300 cursor-pointer" style={{ textShadow: '0 0 10px rgba(0, 212, 255, 0.6)' }}>
                <i className="ri-facebook-circle-line text-2xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center text-primary-blue hover:text-white transition-all duration-300 cursor-pointer" style={{ textShadow: '0 0 10px rgba(0, 212, 255, 0.6)' }}>
                <i className="ri-youtube-line text-2xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-primary-blue font-inter font-semibold text-lg mb-6" style={{ textShadow: '0 0 10px rgba(0, 212, 255, 0.6)' }}>
              QUICK LINKS
            </h4>
            <ul className="space-y-4">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-white hover:text-primary-blue transition-all duration-300 font-inter text-sm relative group cursor-pointer">
                  Home
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></span>
                </button>
              </li>
              <li>
                <Link to="/services" className="text-white hover:text-primary-blue transition-all duration-300 font-inter text-sm relative group cursor-pointer">
                  Services
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></span>
                </Link>
              </li>
              <li>
                <button onClick={() => scrollToSection('pricing')} className="text-white hover:text-primary-blue transition-all duration-300 font-inter text-sm relative group cursor-pointer">
                  Pricing
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></span>
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('merchandise')} className="text-white hover:text-primary-blue transition-all duration-300 font-inter text-sm relative group cursor-pointer">
                  Merchandise
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></span>
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-white hover:text-primary-blue transition-all duration-300 font-inter text-sm relative group cursor-pointer">
                  Contact
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></span>
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-primary-blue hover:text-white transition-all duration-300 font-inter text-sm font-semibold cursor-pointer">
                  Book Now
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-primary-blue font-inter font-semibold text-lg mb-6" style={{ textShadow: '0 0 10px rgba(0, 212, 255, 0.6)' }}>
              OUR SERVICES
            </h4>
            <ul className="space-y-4">
              <li className="text-white font-inter text-sm">Ceramic Coating</li>
              <li className="text-white font-inter text-sm">Paint Correction</li>
              <li className="text-white font-inter text-sm">Interior Detailing</li>
              <li className="text-white font-inter text-sm">Paint Protection Film</li>
              <li className="text-white font-inter text-sm">Engine Bay Detailing</li>
              <li className="text-white font-inter text-sm">Odor Elimination</li>
              <li className="text-white font-inter text-sm">Leather Conditioning</li>
              <li>
                <Link to="/services" className="text-primary-blue hover:text-white transition-all duration-300 font-inter text-sm font-semibold cursor-pointer">
                  View All Services
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-primary-blue font-inter font-semibold text-lg mb-6" style={{ textShadow: '0 0 10px rgba(0, 212, 255, 0.6)' }}>
              GET IN TOUCH
            </h4>
            <div className="space-y-4">
              <a
                href="https://wa.me/12694649163"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white hover:text-primary-blue transition-all duration-300 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                <div>
                  <p className="font-inter text-sm">(269) 464-9163</p>
                  <span className="text-xs text-green-400">WhatsApp Only</span>
                </div>
              </a>
              <div className="flex items-start gap-3 text-white">
                <i className="ri-map-pin-line text-xl text-primary-blue"></i>
                <div>
                  <p className="font-inter text-sm">Elkhart, Indiana</p>
                  <p className="text-xs text-gray-400">Serving Local Area Only</p>
                </div>
              </div>
              <div className="mt-6 rounded-2xl overflow-hidden border-2 border-primary-blue/30" style={{ boxShadow: '0 0 15px rgba(0, 212, 255, 0.3)' }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95234.89384190384!2d-85.9767!3d41.6819!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8816c4f0e6c3e3e3%3A0x1234567890abcdef!2sElkhart%2C%20IN!5e0!3m2!1sen!2sus!4v1234567890123"
                  width="100%"
                  height="200"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Marche Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-blue/20">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 font-inter text-sm text-center md:text-left">
              © 2024 Marche Detailing. All Rights Reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-primary-blue transition-all duration-300 font-inter text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
